/* eslint-disable no-unused-vars */
const STAGING_URL = "https://weatherpredictionapi.intellexio.com";
const LOCAL_URL = "https://weatherprediction.intellexio.com/api";
const config = {
  API_BASE_URL: LOCAL_URL,
};
export default config;
